import React, { useState, useRef, useEffect } from "react";
import "./NewModal.css";
import "./PayoutModal.scss";
import { AlertMessage } from "../common";
import PayoutService from "../../../service/payout";
import ProfileService from "../../../service/profile";
import swal from "sweetalert";
import { useTranslation } from "react-i18next";

function NewModal(props) {
  const { t } = useTranslation();
  const modalRef = useRef(null);
  const service = new PayoutService();
  const profileService = new ProfileService();
  const [notify, setnotify] = useState({
    show: false,
    message: "",
    type: "",
  });
  const handleSweetAlertConfirm = () => {
    // Perform your logic here

    // Close the SweetAlert modal
    swal.close();
  };

  const handleSweetAlertCancel = () => {
    // Close the SweetAlert modal
    swal.close();
  };

  const [valueForAddress, setValueForAddress] = useState({
    country: [],
    province: [],
    barangay: [],
    city: [],
  });

  const [transfer, setTransfer] = useState({
    amount: "",
    grossAmount: 0,
    taxPercentage: props.taxPercentage,
    taxPercentageAmount: 0,
    processingFee: props.processingFee,
    netAmount: 0,
    password: "",
    loading: false,
    debitAmount: 0,
  });
  const encashmentTypes = props.encashmentTypes ?? [],
    releaseMethod = props.releaseMethod ?? [],
    bankDetailsArray = props.bankDetailsArray ?? [],
    addressDetails = props.addressDetails ?? [],
    releaseMethods = props.releaseMethods ?? [];
  const [file, setFile] = useState(null);
  const [encashmentRequest, setEncashmentRequest] = useState({
    type: "",
    amount: "",
    grossAmount: "",
    taxPercentage: props.taxPercentage,
    taxPercentageAmount: "",
    processingFee: props.processingFee,
    netAmount: "",
    password: "",
    loading: false,
    releaseMethod: "",
    address: "",
    country: "",
    province: "",
    city: "",
    barangay: "",
    street: "",
    zipcode: "",
    accountNumber: "",
    bank: "",
    selectedAddress: "",
    delivery: false,
    minPayOut: props.minPayOut,
    bankValue: props.bankValue,
    accountNumber: props.accountNumber,
    verified: props.verified,
    pickupAddress: props.pickupAddress,
    debitAmount: 0,
    file: null,
  });

  const encashmentonChange = async (e) => {
    console.log(e.target.value, "encashmentonchange", e.target.name);
    if (e.target.name === "selectedAddress") {
      const selectedAddress = addressDetails.find(
        (address) => address.id == e.target.value
      );
      setEncashmentRequest((prevRequest) => ({
        ...prevRequest,
        selectedAddress: e.target.value,
        country: selectedAddress.country_id ?? "",
        province: selectedAddress.zone_id ?? "",
        zipcode: selectedAddress.postcode ?? "",
        city: Number(selectedAddress.city) ?? "",
        barangay: selectedAddress.barangay_id ?? "",
        street: selectedAddress.street ?? "",
      }));
      console.log("address id ========", encashmentRequest.selectedAddress);
      console.log("encashmentonchange selectedAddress", selectedAddress);
      let provinceDetails = await profileService.getProvince(
        selectedAddress.country_id
      );
      if (provinceDetails.status) {
        setValueForAddress((prevData) => ({
          ...prevData,
          province: provinceDetails.data ?? [],
        }));
      } else {
        setEncashmentRequest((prevRequest) => ({
          ...prevRequest,
          delivery: false,
        }));
      }
      if (selectedAddress.zone_id != "") {
        let cityDetails = await profileService.getCity(selectedAddress.zone_id);
        if (cityDetails.status) {
          setValueForAddress((prevData) => ({
            ...prevData,
            city: cityDetails.data ?? [],
          }));
        }
      } else {
        setEncashmentRequest((prevRequest) => ({
          ...prevRequest,
          delivery: false,
        }));
      }
      if (selectedAddress.city != "") {
        let barangayDetails = await profileService.getBarangay(
          Number(selectedAddress.city)
        );

        if (barangayDetails.status) {
          let deliverableOrNot = barangayDetails.data.find(
            (item) => item.value == selectedAddress.barangay_id
          );
          console.log(
            deliverableOrNot,
            "deliverableOrNot",
            selectedAddress.barangay_id
          );
          if (deliverableOrNot) {
            console.log("deliverableOrNot inside if condition");
            if (deliverableOrNot.delivery) {
              setEncashmentRequest((prevRequest) => ({
                ...prevRequest,
                delivery: true,
              }));
            }
          } else {
            setEncashmentRequest((prevRequest) => ({
              ...prevRequest,
              delivery: false,
            }));
          }
          setValueForAddress((prevData) => ({
            ...prevData,
            barangay: barangayDetails.data ?? [],
          }));
        } else {
          setEncashmentRequest((prevRequest) => ({
            ...prevRequest,
            delivery: false,
          }));
        }
      } else {
        setEncashmentRequest((prevRequest) => ({
          ...prevRequest,
          delivery: false,
        }));
      }
    } else if (e.target.name === "amount") {
      const amount = parseFloat(e.target.value);
      const debitAmountCalculation = Number(
        (parseFloat(e.target.value) * 20) / 100
      );
      console.log({ debitAmountCalculation });
      const taxPercentage = parseFloat(encashmentRequest.taxPercentage);
      const taxPercentageAmount = Number((amount * taxPercentage) / 100);
      const processingFee = parseFloat(encashmentRequest.processingFee, 10);
      const grossAmount = amount.toFixed(2);
      const debitMemo = props.debitAmount
        ? debitAmountCalculation > Number(props.debitAmount)
          ? Number(props.debitAmount)
          : debitAmountCalculation
        : 0;
      const netAmount = Number(
        amount - (taxPercentageAmount + processingFee + debitMemo)
      ).toFixed(2);
      setEncashmentRequest((prevState) => ({
        ...prevState,
        amount,
        grossAmount,
        taxPercentageAmount,
        netAmount,
        debitAmount: debitMemo,
      }));
    } else if (e.target.files) {
      console.log(e.target.files[0], "e.target.files[0]");
      setEncashmentRequest((prevState) => ({
        ...prevState,
        file: e.target.files[0],
      }));
    } else {
      setEncashmentRequest((prevRequest) => ({
        ...prevRequest,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const transferOnChange = (e) => {
    console.log(e.target.name, "name changes");
    if (e.target.name === "amount") {
      const amount = parseFloat(e.target.value);
      const debitAmountCalculation = Number(
        (parseFloat(e.target.value) * 20) / 100
      );
      const taxPercentage = parseFloat(transfer.taxPercentage);
      const taxPercentageAmount = Number((amount * taxPercentage) / 100);
      const grossAmount = amount.toFixed(2);
      const debitMemo = props.debitAmount
        ? debitAmountCalculation > Number(props.debitAmount)
          ? Number(props.debitAmount)
          : debitAmountCalculation
        : 0;
      setTransfer((prevState) => ({
        ...prevState,
        amount,
        grossAmount,
        taxPercentageAmount,
        netAmount: Number(
          amount -
            Number(taxPercentageAmount + transfer.processingFee + debitMemo)
        ).toFixed(2),
        debitAmount: debitMemo,
      }));
    } else {
      setTransfer((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const notifyDissmissed = () => {
    setnotify((prev) => ({
      ...prev,
      show: false,
    }));
  };

  const CloseIcon = () => (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="15" y1="9" x2="9" y2="15" />
      <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
  );

  useEffect(async () => {
    const modalWrapper = document.querySelector(".modall-wrapper");
    const sweetAlertOverlay = document.querySelector(".swal-overlay");
    const sweetAlertContainer = document.querySelector(".swal-modal");
    const defaultAddress = addressDetails.find((address) => address.default);
    console.log(defaultAddress, "defaultAddress");
    if (defaultAddress) {
      setEncashmentRequest((prevRequest) => ({
        ...prevRequest,
        selectedAddress: defaultAddress.id,
        country: defaultAddress.country_id ?? "",
        province: defaultAddress.zone_id ?? "",
        zipcode: defaultAddress.postcode ?? "",
        city: defaultAddress.city ?? "",
        barangay: defaultAddress.barangay_id ?? "",
        street: defaultAddress.street ?? "",
        pickupAddress: props.pickupAddress,
      }));

      let provinceDetails = await profileService.getProvince(
        defaultAddress.country_id
      );
      if (provinceDetails.status) {
        setValueForAddress((prevData) => ({
          ...prevData,
          province: provinceDetails.data ?? [],
        }));
      }
      if (defaultAddress.zone_id != "") {
        let cityDetails = await profileService.getCity(defaultAddress.zone_id);
        if (cityDetails.status) {
          setValueForAddress((prevData) => ({
            ...prevData,
            city: cityDetails.data ?? [],
          }));
        }
      }
      if (defaultAddress.city != "") {
        let barangayDetails = await profileService.getBarangay(
          Number(defaultAddress.city)
        );

        if (barangayDetails.status) {
          let deliverableOrNot = barangayDetails.data.find(
            (item) => item.value == defaultAddress.barangay_id
          );
          console.log(deliverableOrNot, "deliverableOrNot");
          if (deliverableOrNot) {
            if (deliverableOrNot.delivery) {
              console.log("deliverableOrNot inside if delivery condition");
              setEncashmentRequest((prevRequest) => ({
                ...prevRequest,
                delivery: true,
              }));
            }
          } else {
            setEncashmentRequest((prevRequest) => ({
              ...prevRequest,
              delivery: false,
            }));
          }
          setValueForAddress((prevData) => ({
            ...prevData,
            barangay: barangayDetails.data ?? [],
          }));
        }
      }
    }
    const handleOutsideClick = (event) => {
      console.log(event.target);
      if (
        modalWrapper &&
        event.target.outerHTML.startsWith('<div class="modall-wrapper">')
      ) {
        console.log("Closing modal");
        props.onClose();
      } else if (
        modalWrapper &&
        sweetAlertOverlay &&
        sweetAlertContainer &&
        (!modalRef.current || !modalRef.current.contains(event.target)) &&
        !sweetAlertOverlay.contains(event.target) &&
        !sweetAlertContainer.contains(event.target) &&
        !event.target.classList.contains("swal-button") &&
        !modalWrapper.contains(event.target)
      ) {
        console.log("Closing modal");
        props.onClose();
      }
    };

    let countryDetails = await service.GetCountryDetails();
    if (countryDetails.status) {
      setValueForAddress((prevData) => ({
        ...prevData,
        country: countryDetails.data ?? [],
      }));
    }
    console.log(countryDetails, "countryDetails");
    console.log("encashmentTransferToWalletResult", props.pickupAddress);
    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [props.onClose]);

  // const transactionWalletSubmit = async () => {
  //   setTransfer((prevState) => ({
  //     ...prevState,
  //     loading: true,
  //   }));
  //   let data = { payout_amount: transfer.amount, password: transfer.password };
  //   try {
  //     const errorMessage =
  //       transfer.amount <= 0
  //         ? "Amount must be valid"
  //         : transfer.netAmount <= 0
  //         ? "Net amount should be valid"
  //         : transfer.password === ""
  //         ? "Password cannot be empty"
  //         : "";

  //     if (errorMessage) {
  //       setnotify((prev) => ({
  //         ...prev,
  //         show: true,
  //         type: "danger",
  //         message: errorMessage,
  //       }));
  //       setTransfer((prevState) => ({
  //         ...prevState,
  //         loading: false,
  //       }));
  //       return;
  //     } else {
  //       let encashmentTransferToWalletResult =
  //         await service.encashmentTransferToWallet(data);
  //       if (!encashmentTransferToWalletResult.status) {
  //         setTransfer((prevData) => ({ ...prevData, loading: false }));
  //         setnotify((prev) => ({
  //           ...prev,
  //           show: true,
  //           type: "danger",
  //           message: encashmentTransferToWalletResult.error?.description
  //             ? encashmentTransferToWalletResult.error?.description
  //             : "Some Error Occured..!!",
  //         }));
  //       } else {
  //         setTransfer((prevState) => ({
  //           ...prevState,
  //           amount: 0,
  //           grossAmount: 0,
  //           taxPercentage: props.taxPercentage,
  //           taxPercentageAmount: 0,
  //           processingFee: props.processingFee,
  //           netAmount: 0,
  //           password: "",
  //           loading: false,
  //         }));
  //         props.setReload((prevState) => !prevState);
  //         setnotify((prev) => ({
  //           ...prev,
  //           show: true,
  //           type: "success",
  //           message: "Encashment Completed Successfully.",
  //         }));
  //       }
  //     }
  //   } catch (error) {
  //     setTransfer((prevState) => ({
  //       ...prevState,
  //       loading: false,
  //     }));
  //     console.log(error);
  //     setnotify((prev) => ({
  //       ...prev,
  //       show: true,
  //       type: "danger",
  //       message: "Some Error Occured...!",
  //     }));
  //   }
  // };

  // const encashmentRequestSubmit = async () => {
  //   console.log(
  //     encashmentRequest.releaseMethod,
  //     "encashmentRequest.releaseMethod"
  //   );
  //   setEncashmentRequest((prevState) => ({
  //     ...prevState,
  //     loading: true,
  //   }));
  //   try {
  //     let data = {
  //       password: encashmentRequest.password,
  //       payout_amount: encashmentRequest.amount,
  //       barangayid: encashmentRequest.barangay,
  //       type: encashmentRequest.type,
  //       releaseMethod:
  //         encashmentRequest.type === "Check_Encashment"
  //           ? encashmentRequest.releaseMethod
  //           : "Pickup",
  //       addressid: encashmentRequest.selectedAddress,
  //     };
  //     const errorMessage =
  //       encashmentRequest.amount <= 0
  //         ? "Amount must be valid"
  //         : encashmentRequest.amount < encashmentRequest.minPayOut
  //         ? "Amount should be greater than minimum payout amount"
  //         : encashmentRequest.netAmount <= 0
  //         ? "Net amount should be valid"
  //         : encashmentRequest.password === ""
  //         ? "Password cannot be empty"
  //         : encashmentRequest.type == ""
  //         ? "Encashment Type is Required"
  //         : encashmentRequest.type === "ATM_Encashment" &&
  //           encashmentRequest.verified === false
  //         ? "Bank Details Verification Pending"
  //         : encashmentRequest.type === "Check_Encashment" &&
  //           encashmentRequest.releaseMethod == ""
  //         ? "Release Method Is Required"
  //         : encashmentRequest.type === "Check_Encashment" &&
  //           encashmentRequest.releaseMethod === "shipout" &&
  //           encashmentRequest.delivery === false
  //         ? "Warning! Address is included in the Out Of Delivery Zone. Please ship to other serviceable address"
  //         : encashmentRequest.releaseMethod === "pickup-assigned" &&
  //           encashmentRequest.file == null
  //         ? "Please select and upload a signed form"
  //         : "";

  //     if (errorMessage) {
  //       setnotify((prev) => ({
  //         ...prev,
  //         show: true,
  //         type: "danger",
  //         message: errorMessage,
  //       }));
  //       setEncashmentRequest((prevState) => ({
  //         ...prevState,
  //         loading: false,
  //       }));
  //       return;
  //     } else {
  //       const showAlert = async (title, contentHTML, proceedButtonText) => {
  //         const wrapper = document.createElement("div");
  //         wrapper.innerHTML = contentHTML;
  //         return await swal({
  //           title: title,
  //           content: wrapper,
  //           icon: "warning",
  //           buttons: ["No", proceedButtonText],
  //           dangerMode: true,
  //         });
  //       };

  //       const processTransaction = async () => {
  //         const transactionWrapper = document.createElement("div");
  //         transactionWrapper.innerHTML = `
  //           <div style="font-family: Arial, sans-serif; font-size: 14px; font-weight: bold;">
  //             <div>Gross Amount: <span style="float: right;">${
  //               encashmentRequest.grossAmount
  //             }</span></div>
  //             <div>Deduction: <span style="float: right;">${
  //               encashmentRequest.processingFee +
  //               encashmentRequest.taxPercentageAmount
  //             }</span></div>
  //             <div>Debit Memo: <span style="float: right;">${
  //               encashmentRequest.debitAmount
  //             }</span></div>
  //             <div>Net Amount: <span style="float: right;">${
  //               encashmentRequest.netAmount
  //             }</span></div>
  //           </div>
  //           </br>
  //           <div>${props.confirmation_text}</div>
  //         `;
  //         const confirmTransaction = await swal({
  //           title: "Transaction Summary",
  //           content: transactionWrapper,
  //           icon: "warning",
  //           buttons: ["Cancel", "Confirm"],
  //           dangerMode: true,
  //         });

  //         if (confirmTransaction) {
  //           console.log({ data });
  //           let requestResponse;
  //           if (data.releaseMethod === "pickup-assigned") {
  //             console.log("formData");
  //             const formData = new FormData();
  //             formData.append("file", encashmentRequest.file);
  //             formData.append("addressid", data.addressid);
  //             formData.append("barangayid", data.barangayid);
  //             formData.append("password", data.password);
  //             formData.append("payout_amount", data.payout_amount);
  //             formData.append("releaseMethod", data.releaseMethod);
  //             formData.append("type", data.type);
  //             console.log({ formData });
  //             requestResponse = await service.pickUpAssignedTransfer(formData);
  //           } else {
  //             requestResponse = await service.encashmentTransfer(data);
  //             setEncashmentRequest((prevState) => ({
  //               ...prevState,
  //               loading: false,
  //             }));
  //           }

  //           const notificationMessage = requestResponse.status
  //             ? {
  //                 type: "success",
  //                 message: "Encashment Request Sent Successfully.",
  //               }
  //             : {
  //                 type: "danger",
  //                 message:
  //                   requestResponse.error?.description ||
  //                   "Some Error Occurred..!!",
  //               };

  //           if (requestResponse.status) {
  //             setEncashmentRequest({
  //               type: "",
  //               amount: 0,
  //               grossAmount: 0,
  //               taxPercentage: props.taxPercentage,
  //               taxPercentageAmount: 0,
  //               processingFee: props.processingFee,
  //               netAmount: 0,
  //               password: "",
  //               loading: false,
  //               releaseMethod: "",
  //               address: "",
  //               country: "",
  //               province: "",
  //               city: "",
  //               barangay: "",
  //               street: "",
  //               zipcode: "",
  //               bank: "",
  //               selectedAddress: "",
  //               delivery: false,
  //               minPayOut: props.minPayOut,
  //               bankValue: props.bankValue,
  //               accountNumber: props.accountNumber ?? "",
  //               verified: props.verified,
  //               pickupAddress: props.pickupAddress,
  //             });
  //             props.setReload((prevState) => !prevState);
  //           }

  //           setnotify((prev) => ({
  //             ...prev,
  //             show: true,
  //             ...notificationMessage,
  //           }));
  //         } else {
  //           setEncashmentRequest((prevState) => ({
  //             ...prevState,
  //             loading: false,
  //           }));
  //           setnotify((prev) => ({
  //             ...prev,
  //             show: true,
  //             type: "danger",
  //             message: "Encashment Request Cancelled.",
  //           }));
  //         }
  //       };

  //       const memoText = props.debitAmount
  //         ? props.debit_memo_text
  //         : props.reminder +
  //           '</br><b><h2 style="color:"black";font-weight:800;font-size:27px;">Disclaimer</h2></b></br>' +
  //           props.disclaimer;
  //       const proceedButtonText = props.debitAmount
  //         ? "Proceed"
  //         : "Process Encashment";
  //       const titleText = props.debitAmount ? "Important Notice" : "Reminder";

  //       const initialAlert = await showAlert(
  //         titleText,
  //         memoText,
  //         proceedButtonText
  //       );

  //       if (initialAlert) {
  //         if (props.debitAmount) {
  //           const secondaryAlert = await showAlert(
  //             "Reminder",
  //             `${props.reminder} </br> <b><h2 style="color:"black";font-weight:800;font-size:27px;">Disclaimer</h2></b></br> ${props.disclaimer}`,
  //             "Process Encashment"
  //           );
  //           if (secondaryAlert) {
  //             await processTransaction();
  //           }
  //         } else {
  //           await processTransaction();
  //         }
  //       }
  //     }

  //     // else {
  //     //         if (props.debitAmount) {
  //     //           const wrapper = document.createElement("div");
  //     //           wrapper.innerHTML = `${props.debit_memo_text}`;
  //     //           const debitMemoEncashment = await swal({
  //     //             title: "Reminder",
  //     //             content: wrapper,
  //     //             icon: "warning",
  //     //             buttons: ["No", "Proceed"], // Customize button labels
  //     //             dangerMode: true,
  //     //           });
  //     //           if (debitMemoEncashment) {
  //     //             const wrapper = document.createElement("div");
  //     //             wrapper.innerHTML = `${props.reminder} </br> <b><h2 style="color:"black";font-weight:800;font-size:27px;">Disclaimer</h2></b></br> ${props.disclaimer}`;
  //     //             const processEncashment = await swal({
  //     //               title: "Reminder",
  //     //               content: wrapper,
  //     //               icon: "warning",
  //     //               buttons: ["No", "Process Encashment"], // Customize button labels
  //     //               dangerMode: true,
  //     //             });

  //     //             if (processEncashment) {
  //     //               const transactionWrapper = document.createElement("div");
  //     //               transactionWrapper.innerHTML = `<div style="font-family: Arial, sans-serif; font-size: 14px; font-weight: bold;">
  //     //       <div>Gross Amount: <span style="float: right;">${
  //     //         encashmentRequest.grossAmount
  //     //       }</span></div>
  //     //       <div>Deduction: <span style="float: right;">${
  //     //         encashmentRequest.processingFee + encashmentRequest.taxPercentageAmount
  //     //       }</span></div>
  //     //       <div>Debit Memo: <span style="float: right;">0.00</span></div>
  //     //       <div>Net Amount: <span style="float: right;">${
  //     //         encashmentRequest.netAmount
  //     //       }</span></div>
  //     //   </div>
  //     //   </br>
  //     //   <div>
  //     //             ${props.confirmation_text}
  //     //   </div>
  //     //   `;
  //     //               const willDelete = await swal({
  //     //                 title: "Transaction Summary",
  //     //                 // text: "This action cannot be undone",
  //     //                 content: transactionWrapper,
  //     //                 icon: "warning",
  //     //                 buttons: ["Cancel", "Confirm"], // Customize button labels
  //     //                 dangerMode: true,
  //     //               });

  //     //               if (willDelete) {
  //     //                 let requestResponse = await service.encashmentTransfer(data);
  //     //                 setEncashmentRequest((prevState) => ({
  //     //                   ...prevState,
  //     //                   loading: false,
  //     //                 }));
  //     //                 if (requestResponse.status) {
  //     //                   setEncashmentRequest((prevState) => ({
  //     //                     ...prevState,
  //     //                     type: "",
  //     //                     amount: 0,
  //     //                     grossAmount: 0,
  //     //                     taxPercentage: props.taxPercentage,
  //     //                     taxPercentageAmount: 0,
  //     //                     processingFee: props.processingFee,
  //     //                     netAmount: 0,
  //     //                     password: "",
  //     //                     loading: false,
  //     //                     releaseMethod: "",
  //     //                     address: "",
  //     //                     country: "",
  //     //                     province: "",
  //     //                     city: "",
  //     //                     barangay: "",
  //     //                     street: "",
  //     //                     zipcode: "",
  //     //                     bank: "",
  //     //                     selectedAddress: "",
  //     //                     delivery: false,
  //     //                     minPayOut: props.minPayOut,
  //     //                     bankValue: props.bankValue,
  //     //                     accountNumber: props.accountNumber ?? "",
  //     //                     verified: props.verified,
  //     //                     pickupAddress: props.pickupAddress,
  //     //                   }));
  //     //                   props.setReload((prevState) => !prevState);
  //     //                   setnotify((prev) => ({
  //     //                     ...prev,
  //     //                     show: true,
  //     //                     type: "success",
  //     //                     message: "Encashment Request Sent Successfully.",
  //     //                   }));
  //     //                 } else {
  //     //                   setnotify((prev) => ({
  //     //                     ...prev,
  //     //                     show: true,
  //     //                     type: "danger",
  //     //                     message: requestResponse.error?.description
  //     //                       ? requestResponse.error?.description
  //     //                       : "Some Error Occured..!!",
  //     //                   }));
  //     //                 }
  //     //               } else {
  //     //                 setEncashmentRequest((prevState) => ({
  //     //                   ...prevState,
  //     //                   loading: false,
  //     //                 }));
  //     //                 setnotify((prev) => ({
  //     //                   ...prev,
  //     //                   show: true,
  //     //                   type: "danger",
  //     //                   message: "Encashment Request Cancelled.",
  //     //                 }));
  //     //               }
  //     //             } else {
  //     //               setEncashmentRequest((prevState) => ({
  //     //                 ...prevState,
  //     //                 loading: false,
  //     //               }));
  //     //               setnotify((prev) => ({
  //     //                 ...prev,
  //     //                 show: true,
  //     //                 type: "danger",
  //     //                 message: "Encashment Request Cancelled.",
  //     //               }));
  //     //             }
  //     //           }
  //     //         } else {
  //     //           const wrapper = document.createElement("div");
  //     //           wrapper.innerHTML = `${props.reminder} </br> <b><h2 style="color:"black";font-weight:800;font-size:27px;">Disclaimer</h2></b></br> ${props.disclaimer}`;
  //     //           const processEncashment = await swal({
  //     //             title: "Reminder",
  //     //             content: wrapper,
  //     //             icon: "warning",
  //     //             buttons: ["No", "Process Encashment"], // Customize button labels
  //     //             dangerMode: true,
  //     //           });

  //     //           if (processEncashment) {
  //     //             const transactionWrapper = document.createElement("div");
  //     //             transactionWrapper.innerHTML = `<div style="font-family: Arial, sans-serif; font-size: 14px; font-weight: bold;">
  //     //     <div>Gross Amount: <span style="float: right;">${
  //     //       encashmentRequest.grossAmount
  //     //     }</span></div>
  //     //     <div>Deduction: <span style="float: right;">${
  //     //       encashmentRequest.processingFee + encashmentRequest.taxPercentageAmount
  //     //     }</span></div>
  //     //     <div>Debit Memo: <span style="float: right;">0.00</span></div>
  //     //     <div>Net Amount: <span style="float: right;">${
  //     //       encashmentRequest.netAmount
  //     //     }</span></div>
  //     // </div>
  //     // </br>
  //     // <div>
  //     //           ${props.confirmation_text}
  //     // </div>
  //     // `;
  //     //             const willDelete = await swal({
  //     //               title: "Transaction Summary",
  //     //               // text: "This action cannot be undone",
  //     //               content: transactionWrapper,
  //     //               icon: "warning",
  //     //               buttons: ["Cancel", "Confirm"], // Customize button labels
  //     //               dangerMode: true,
  //     //             });

  //     //             if (willDelete) {
  //     //               let requestResponse = await service.encashmentTransfer(data);
  //     //               setEncashmentRequest((prevState) => ({
  //     //                 ...prevState,
  //     //                 loading: false,
  //     //               }));
  //     //               if (requestResponse.status) {
  //     //                 setEncashmentRequest((prevState) => ({
  //     //                   ...prevState,
  //     //                   type: "",
  //     //                   amount: 0,
  //     //                   grossAmount: 0,
  //     //                   taxPercentage: props.taxPercentage,
  //     //                   taxPercentageAmount: 0,
  //     //                   processingFee: props.processingFee,
  //     //                   netAmount: 0,
  //     //                   password: "",
  //     //                   loading: false,
  //     //                   releaseMethod: "",
  //     //                   address: "",
  //     //                   country: "",
  //     //                   province: "",
  //     //                   city: "",
  //     //                   barangay: "",
  //     //                   street: "",
  //     //                   zipcode: "",
  //     //                   bank: "",
  //     //                   selectedAddress: "",
  //     //                   delivery: false,
  //     //                   minPayOut: props.minPayOut,
  //     //                   bankValue: props.bankValue,
  //     //                   accountNumber: props.accountNumber ?? "",
  //     //                   verified: props.verified,
  //     //                   pickupAddress: props.pickupAddress,
  //     //                 }));
  //     //                 props.setReload((prevState) => !prevState);
  //     //                 setnotify((prev) => ({
  //     //                   ...prev,
  //     //                   show: true,
  //     //                   type: "success",
  //     //                   message: "Encashment Request Sent Successfully.",
  //     //                 }));
  //     //               } else {
  //     //                 setnotify((prev) => ({
  //     //                   ...prev,
  //     //                   show: true,
  //     //                   type: "danger",
  //     //                   message: requestResponse.error?.description
  //     //                     ? requestResponse.error?.description
  //     //                     : "Some Error Occured..!!",
  //     //                 }));
  //     //               }
  //     //             } else {
  //     //               setEncashmentRequest((prevState) => ({
  //     //                 ...prevState,
  //     //                 loading: false,
  //     //               }));
  //     //               setnotify((prev) => ({
  //     //                 ...prev,
  //     //                 show: true,
  //     //                 type: "danger",
  //     //                 message: "Encashment Request Cancelled.",
  //     //               }));
  //     //             }
  //     //           } else {
  //     //             setEncashmentRequest((prevState) => ({
  //     //               ...prevState,
  //     //               loading: false,
  //     //             }));
  //     //             setnotify((prev) => ({
  //     //               ...prev,
  //     //               show: true,
  //     //               type: "danger",
  //     //               message: "Encashment Request Cancelled.",
  //     //             }));
  //     //           }
  //     //         }
  //     //       }
  //   } catch (error) {
  //     setEncashmentRequest((prevState) => ({
  //       ...prevState,
  //       loading: false,
  //     }));
  //     console.log(error);
  //     setnotify((prev) => ({
  //       ...prev,
  //       show: true,
  //       type: "danger",
  //       message: "Some Error Occured...!",
  //     }));
  //   }
  // };

  const encashmentRequestSubmit = async () => {
    console.log(
      encashmentRequest.releaseMethod,
      "encashmentRequest.releaseMethod"
    );
    setEncashmentRequest((prevState) => ({
      ...prevState,
      loading: true,
    }));
    try {
      let data = {
        password: encashmentRequest.password,
        payout_amount: encashmentRequest.amount,
        barangayid: encashmentRequest.barangay,
        type: encashmentRequest.type,
        releaseMethod:
          encashmentRequest.type === "Check_Encashment"
            ? encashmentRequest.releaseMethod
            : "Pickup",
        addressid: encashmentRequest.selectedAddress,
      };
      const errorMessage =
        encashmentRequest.amount <= 0
          ? "Amount must be valid"
          : encashmentRequest.amount < encashmentRequest.minPayOut
          ? "Amount should be greater than minimum payout amount"
          : encashmentRequest.netAmount <= 0
          ? "Net amount should be valid"
          : encashmentRequest.password === ""
          ? "Password cannot be empty"
          : encashmentRequest.type == ""
          ? "Encashment Type is Required"
          : encashmentRequest.type === "ATM_Encashment" &&
            encashmentRequest.verified === false
          ? "Bank Details Verification Pending"
          : encashmentRequest.type === "Check_Encashment" &&
            encashmentRequest.releaseMethod == ""
          ? "Release Method Is Required"
          : encashmentRequest.type === "Check_Encashment" &&
            encashmentRequest.releaseMethod === "shipout" &&
            encashmentRequest.delivery === false
          ? "Warning! Address is included in the Out Of Delivery Zone. Please ship to other serviceable address"
          : encashmentRequest.releaseMethod === "pickup-assigned" &&
            encashmentRequest.file == null
          ? "Please select and upload a signed form"
          : "";

      if (errorMessage) {
        setnotify((prev) => ({
          ...prev,
          show: true,
          type: "danger",
          message: errorMessage,
        }));
        setEncashmentRequest((prevState) => ({
          ...prevState,
          loading: false,
        }));
        return;
      } else {
        const showAlert = async (title, contentHTML, proceedButtonText) => {
          const wrapper = document.createElement("div");
          wrapper.innerHTML = contentHTML;
          return await swal({
            title: title,
            content: wrapper,
            icon: "warning",
            buttons: ["No", proceedButtonText],
            dangerMode: true,
          });
        };

        const processTransaction = async () => {
          const transactionWrapper = document.createElement("div");
          transactionWrapper.innerHTML = `
  <div style="font-family: Arial, sans-serif; font-size: 14px; font-weight: bold; text-align: center;">
    <table style="width: 50%; margin: 0 auto; text-align: center; border-collapse: collapse;">
      <tr>
        <td style="text-align: left;">Gross Amount:</td>
        <td style="text-align: right;">${encashmentRequest.grossAmount}</td>
      </tr>
      <tr>
        <td style="text-align: left;">Deduction:</td>
        <td style="text-align: right;">${
          encashmentRequest.processingFee +
          encashmentRequest.taxPercentageAmount
        }</td>
      </tr>
      <tr>
        <td style="text-align: left;">Debit Memo:</td>
        <td style="text-align: right;">${encashmentRequest.debitAmount}</td>
      </tr>
      <tr>
        <td style="text-align: left;">Net Amount:</td>
        <td style="text-align: right;">${encashmentRequest.netAmount}</td>
      </tr>
    </table>
  </div>
  <br>
  <div style="text-align: center;">${props.confirmation_text}</div>
`;
          const confirmTransaction = await swal({
            title: "Transaction Summary",
            content: transactionWrapper,
            icon: "warning",
            buttons: ["Cancel", "Confirm"],
            dangerMode: true,
          });

          if (confirmTransaction) {
            console.log({ data });
            let requestResponse;
            if (data.releaseMethod === "pickup-assigned") {
              console.log("formData");
              const formData = new FormData();
              formData.append("file", encashmentRequest.file);
              formData.append("addressid", data.addressid);
              formData.append("barangayid", data.barangayid);
              formData.append("password", data.password);
              formData.append("payout_amount", data.payout_amount);
              formData.append("releaseMethod", data.releaseMethod);
              formData.append("type", data.type);
              console.log({ formData });
              requestResponse = await service.pickUpAssignedTransfer(formData);
            } else {
              requestResponse = await service.encashmentTransfer(data);
              setEncashmentRequest((prevState) => ({
                ...prevState,
                loading: false,
              }));
            }

            const notificationMessage = requestResponse.status
              ? {
                  type: "success",
                  message: "Encashment Request Sent Successfully.",
                }
              : {
                  type: "danger",
                  message:
                    requestResponse.error?.description ||
                    "Some Error Occurred..!!",
                };

            if (requestResponse.status) {
              setEncashmentRequest({
                type: "",
                amount: 0,
                grossAmount: 0,
                taxPercentage: props.taxPercentage,
                taxPercentageAmount: 0,
                processingFee: props.processingFee,
                netAmount: 0,
                password: "",
                loading: false,
                releaseMethod: "",
                address: "",
                country: "",
                province: "",
                city: "",
                barangay: "",
                street: "",
                zipcode: "",
                bank: "",
                selectedAddress: "",
                delivery: false,
                minPayOut: props.minPayOut,
                bankValue: props.bankValue,
                accountNumber: props.accountNumber ?? "",
                verified: props.verified,
                pickupAddress: props.pickupAddress,
              });
              props.setReload((prevState) => !prevState);
            }

            setnotify((prev) => ({
              ...prev,
              show: true,
              ...notificationMessage,
            }));
          } else {
            setEncashmentRequest((prevState) => ({
              ...prevState,
              loading: false,
            }));
            setnotify((prev) => ({
              ...prev,
              show: true,
              type: "danger",
              message: "Encashment Request Cancelled.",
            }));
          }
        };

        const memoText =
          props.reminder +
          '</br><b><h2 style="color:"black";font-weight:800;font-size:27px;">Disclaimer</h2></b></br>' +
          props.disclaimer;
        const proceedButtonText = "Process Encashment";
        const titleText = "Reminder";

        const initialAlert = await showAlert(
          titleText,
          memoText,
          proceedButtonText
        );

        if (initialAlert) {
          await processTransaction();
        } else {
          setEncashmentRequest((prevState) => ({
            ...prevState,
            loading: false,
          }));
        }
      }
    } catch (error) {
      setEncashmentRequest((prevState) => ({
        ...prevState,
        loading: false,
      }));
      console.log(error);
      setnotify((prev) => ({
        ...prev,
        show: true,
        type: "danger",
        message: "Some Error Occured...!",
      }));
    }
  };

  const transactionWalletSubmit = async () => {
    setTransfer((prevState) => ({
      ...prevState,
      loading: true,
    }));
    let data = { payout_amount: transfer.amount, password: transfer.password };
    try {
      const errorMessage =
        transfer.amount <= 0
          ? "Amount must be valid"
          : transfer.netAmount <= 0
          ? "Net amount should be valid"
          : transfer.password === ""
          ? "Password cannot be empty"
          : "";

      if (errorMessage) {
        setnotify((prev) => ({
          ...prev,
          show: true,
          type: "danger",
          message: errorMessage,
        }));
        setTransfer((prevState) => ({
          ...prevState,
          loading: false,
        }));
        return;
      } else {
        const showAlert = async (title, contentHTML, proceedButtonText) => {
          const wrapper = document.createElement("div");
          wrapper.innerHTML = contentHTML;
          return await swal({
            title: title,
            content: wrapper,
            icon: "warning",
            buttons: ["No", proceedButtonText],
            dangerMode: true,
          });
        };
        const processTransaction = async () => {
          const transactionWrapper = document.createElement("div");
          transactionWrapper.innerHTML = `
  <div style="font-family: Arial, sans-serif; font-size: 14px; font-weight: bold;">
    <table style="width: 50%; margin: 0 auto; text-align: center; border-collapse: collapse;">
      <tr>
        <td style="text-align: left;">Gross Amount:</td>
        <td style="text-align: right;">${transfer.grossAmount}</td>
      </tr>
      <tr>
        <td style="text-align: left;">Deduction:</td>
        <td style="text-align: right;">${
          transfer.processingFee + transfer.taxPercentageAmount
        }</td>
      </tr>
      <tr>
        <td style="text-align: left;">Debit Memo:</td>
        <td style="text-align: right;">${transfer.debitAmount}</td>
      </tr>
      <tr>
        <td style="text-align: left;">Net Amount:</td>
        <td style="text-align: right;">${transfer.netAmount}</td>
      </tr>
    </table>
  </div>
  <br>
  <div style="text-align: center;">${props.confirmation_text}</div>
`;

          const confirmTransaction = await swal({
            title: "Transaction Summary",
            content: transactionWrapper,
            icon: "warning",
            buttons: ["Cancel", "Confirm"],
            dangerMode: true,
          });

          if (confirmTransaction) {
            let encashmentTransferToWalletResult =
              await service.encashmentTransferToWallet(data);
            if (!encashmentTransferToWalletResult.status) {
              setTransfer((prevData) => ({ ...prevData, loading: false }));
              setnotify((prev) => ({
                ...prev,
                show: true,
                type: "danger",
                message: encashmentTransferToWalletResult.error?.description
                  ? encashmentTransferToWalletResult.error?.description
                  : "Some Error Occured..!!",
              }));
            } else {
              setTransfer((prevState) => ({
                ...prevState,
                amount: 0,
                grossAmount: 0,
                taxPercentage: props.taxPercentage,
                taxPercentageAmount: 0,
                processingFee: props.processingFee,
                netAmount: 0,
                password: "",
                loading: false,
              }));
              props.setReload((prevState) => !prevState);
              setnotify((prev) => ({
                ...prev,
                show: true,
                type: "success",
                message: "Encashment Completed Successfully.",
              }));
            }
          } else {
            setTransfer((prevState) => ({
              ...prevState,
              loading: false,
            }));
          }
        };

        const memoText =
          props.reminder +
          '</br><b><h2 style="color:"black";font-weight:800;font-size:27px;">Disclaimer</h2></b></br>' +
          props.disclaimer;
        const proceedButtonText = "Process Encashment";
        const titleText = "Reminder";

        const initialAlert = await showAlert(
          titleText,
          memoText,
          proceedButtonText
        );

        if (initialAlert) {
          await processTransaction();
        } else {
          setTransfer((prevState) => ({
            ...prevState,
            loading: false,
          }));
        }
      }
    } catch (error) {
      setTransfer((prevState) => ({
        ...prevState,
        loading: false,
      }));
      console.log(error);
      setnotify((prev) => ({
        ...prev,
        show: true,
        type: "danger",
        message: "Some Error Occured...!",
      }));
    }
  };

  return (
    <div className="modall-wrapper">
      <div className="modall" ref={modalRef}>
        <button className="close-button" onClick={props.onClose}>
          <CloseIcon />
        </button>

        {props.item.id === 1 && (
          <div className="modals">
            <div className="bordergreen"></div>
            <div className="headlabel">Encashment - Transfer to Wallet</div>
            <div style={{ fontSize: "10px" }}>Please enter below details </div>
            <br />
            <br />
            <div className="row">
              <div className="col-md-12">
                <div className="labelClass">
                  <label for="">Amount *</label>
                </div>
                <input
                  placeholder="Enter Amount"
                  type="number"
                  name="amount"
                  value={transfer.amount}
                  onChange={transferOnChange}
                />
              </div>
            </div>
            <hr className="hr-custom" />
            <div className="headlabel">Review Encashment Details</div>
            <div className="row">
              <div className="col-md-12">
                <div className="labelClass">
                  <label for="">Gross Amount:</label>
                </div>
                <input
                  placeholder="Enter Amount"
                  type="text"
                  value={transfer.grossAmount}
                  onChange={transferOnChange}
                  disabled={true}
                />
              </div>
              <div className="col-md-12">
                <div className="labelClass">
                  <label for="">TAX: ({`${transfer.taxPercentage}%`}):</label>
                </div>
                <input
                  placeholder="Enter Amount"
                  type="text"
                  value={transfer.taxPercentageAmount}
                  disabled={true}
                />
              </div>
              <div className="col-md-12">
                <div className="labelClass">
                  <label for="">Processing Fee:</label>
                </div>
                <input
                  placeholder="Enter Amount"
                  type="text"
                  value={transfer.processingFee}
                  disabled={true}
                />
              </div>
              <div className="col-md-12">
                <div className="labelClass">
                  <label for="">Net Amount:</label>
                </div>
                <input type="text" value={transfer.netAmount} disabled={true} />
              </div>
              <div className="col-md-12">
                <div className="labelClass">
                  <label for="">Debit Amount:</label>
                </div>
                <input
                  type="text"
                  value={transfer.debitAmount}
                  disabled={true}
                />
              </div>
            </div>
            <hr className="hr-custom" />
            <div className="row">
              <div className="col-md-12">
                <div className="labelClass">
                  <label for="">Enter Password *</label>
                </div>
                <input
                  placeholder="Enter Password"
                  type="password"
                  name="password"
                  value={transfer.password}
                  onChange={transferOnChange}
                />
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-md-6">
                <button
                  type="button"
                  style={{
                    backgroundColor: "#00AF50",
                    padding: "1em",
                    borderRadius: ".2em",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={transactionWalletSubmit}
                  disabled={transfer.loading}
                >
                  {transfer.loading ? "Loading" : "Process Encashment"}
                </button>
              </div>
            </div>
          </div>
        )}

        {props.item.id === 3 && (
          <div className="modalCommonStyle">
            <div
              className="offcanvas offcanvas-end"
              tabindex="-1"
              id="offcanvasRight"
              aria-labelledby="offcanvasRightLabel"
            >
              <div className="offcanvas-header">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>
              <div className="offcanvas-body">
                <div className="borderTopLine"></div>
                <h5>{props.item.label}</h5>
                <p>Please enter below details</p>
                <div className="inputClassFiles">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="labelClass">
                        <label for="">Amount</label>
                      </div>
                      <input
                        placeholder="Amount"
                        type="number"
                        name="amount"
                        value={encashmentRequest.amount}
                        onChange={encashmentonChange}
                      />
                    </div>
                    <div className="col-md-6">
                      <div className="labelClass">
                        <label for="">Type</label>
                      </div>
                      <select
                        name="type"
                        id="type"
                        value={encashmentRequest.type}
                        onChange={encashmentonChange}
                        defaultValue=""
                      >
                        <option value="" disabled>
                          Select Encashment Type
                        </option>
                        {encashmentTypes.map((type) => {
                          return (
                            <option value={type}>{t(`Common.${type}`)}</option>
                          );
                        })}
                      </select>
                    </div>
                    {encashmentRequest.type == "ATM_Encashment" && (
                      <>
                        <div className="col-md-6">
                          <div className="labelClass">
                            <label for="">Bank Details:</label>
                          </div>
                          <select
                            name="bankValue"
                            id="bankValue"
                            value={encashmentRequest.bankValue}
                            onChange={encashmentonChange}
                            defaultValue=""
                            disabled={true}
                          >
                            <option value="">Select Bank</option>
                            {bankDetailsArray.map((type) => {
                              return (
                                <option value={type.value} key={type.code}>
                                  {type.title}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        <div className="col-md-6">
                          <div className="labelClass">
                            <label for="">Account Number:</label>
                          </div>
                          <input
                            placeholder="Account Number"
                            type="text"
                            name="accountNumber"
                            value={encashmentRequest.accountNumber}
                            disabled={true}
                          />
                        </div>

                        {encashmentRequest.type == "ATM_Encashment" &&
                          encashmentRequest.verified === false && (
                            <div className="col-md-12 m-2">
                              <p style={{ color: "red" }}>
                                Bank Details Verification Pending.
                              </p>
                            </div>
                          )}
                      </>
                    )}
                  </div>
                  <h3>Review Encashment Details</h3>
                  <br />
                  <div className="row">
                    <div className="col-md-6">
                      <div className="labelClass">
                        <label for="">Gross Amount:</label>
                      </div>
                      <input
                        placeholder="Gross Amount"
                        type="text"
                        name="grossAmount"
                        value={encashmentRequest.grossAmount}
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-6">
                      <div className="labelClass">
                        <label for="">
                          W/TAX ({encashmentRequest.taxPercentage}%)
                        </label>
                      </div>
                      <input
                        placeholder="Tax Amount"
                        type="text"
                        name="taxPercentageAmount"
                        value={encashmentRequest.taxPercentageAmount}
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-6">
                      <div className="labelClass">
                        <label for="">Processing Fee:</label>
                      </div>
                      <input
                        placeholder="Processing Fee"
                        type="text"
                        name="processingFee"
                        value={encashmentRequest.processingFee}
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-6">
                      <div className="labelClass">
                        <label for="">Net Amount:</label>
                      </div>
                      <input
                        placeholder="Net Amount"
                        type="text"
                        name="netAmount"
                        value={encashmentRequest.netAmount}
                        disabled={true}
                      />
                    </div>
                    {/* for check encashment*/}
                    {encashmentRequest.type == "Check_Encashment" && (
                      <>
                        {/* release method*/}
                        <div className="col-md-6">
                          <div className="labelClass">
                            <label for="">Release Method:</label>
                          </div>
                          <select
                            name="releaseMethod"
                            id="type"
                            value={encashmentRequest.releaseMethod}
                            onChange={encashmentonChange}
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Select Release Method
                            </option>
                            {releaseMethods.map((type) => {
                              return (
                                <option value={type.slug}>{type.name}</option>
                              );
                            })}
                          </select>
                        </div>
                        {encashmentRequest.releaseMethod == "Shipout" && (
                          <div className="col-md-6">
                            <div className="labelClass">
                              <label for="">Address:</label>
                            </div>
                            <select
                              name="selectedAddress"
                              id="type"
                              value={encashmentRequest.selectedAddress}
                              onChange={encashmentonChange}
                              defaultValue=""
                            >
                              <option value="" disabled>
                                Select Address{" "}
                              </option>
                              {addressDetails.map((address) => {
                                return (
                                  <option value={address.id}>
                                    {address.addressName}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        )}

                        {encashmentRequest.type == "Check_Encashment" &&
                          encashmentRequest.releaseMethod == "Shipout" &&
                          encashmentRequest.delivery == false && (
                            <div className="col-md-12">
                              <p style={{ color: "red" }}>
                                <b>Warning!</b> Address is included in the ODZ
                                (out of delivery zone). Please ship to other
                                serviceable address.{" "}
                                <a
                                  href="https://docs.google.com/spreadsheets/d/1UL4RJuAf5bVPsJCIRAg8mUFcy3kpwUVj/edit#gid=193686198"
                                  style={{
                                    color: "red",
                                    textDecoration: "underline",
                                  }}
                                >
                                  Click the link to view the nearest valid
                                  location.
                                </a>
                              </p>
                            </div>
                          )}
                        {/*  not need for pickup */}
                        {(encashmentRequest.releaseMethod === "Pickup" ||
                          encashmentRequest.releaseMethod ===
                            "pickup-assigned") && (
                          <div className="col-md-12 m-2">
                            <p style={{ color: "red" }}>
                              {encashmentRequest.pickupAddress}
                            </p>
                          </div>
                        )}
                        {encashmentRequest.releaseMethod == "Shipout" && (
                          <>
                            <div className="col-md-6">
                              <div className="labelClass">
                                <label for="">Country *</label>
                              </div>
                              <select
                                name="country"
                                id="country"
                                value={encashmentRequest.country}
                                onChange={encashmentonChange}
                                defaultValue=""
                                disabled={true}
                              >
                                <option value="">Select Country </option>
                                {valueForAddress.country.map(
                                  (singleCountry) => {
                                    return (
                                      <option value={singleCountry.country_id}>
                                        {singleCountry.name}
                                      </option>
                                    );
                                  }
                                )}
                              </select>
                            </div>
                            {/* */}
                            <div className="col-md-6">
                              <div className="labelClass">
                                <label for="">Province *</label>
                              </div>
                              <select
                                name="province"
                                id="province"
                                value={encashmentRequest.province}
                                onChange={encashmentonChange}
                                defaultValue=""
                                disabled={true}
                              >
                                <option value="">Select Province</option>
                                {valueForAddress.province.map(
                                  (singleprovince) => {
                                    return (
                                      <option value={singleprovince.value}>
                                        {singleprovince.title}
                                      </option>
                                    );
                                  }
                                )}
                              </select>
                            </div>
                            <div className="col-md-6">
                              <div className="labelClass">
                                <label for="">City *</label>
                              </div>
                              <select
                                name="city"
                                id="city"
                                value={encashmentRequest.city}
                                onChange={encashmentonChange}
                                defaultValue=""
                                disabled={true}
                              >
                                <option value="">Select City </option>
                                {valueForAddress.city.map((singleCity) => {
                                  return (
                                    <option value={singleCity.value}>
                                      {singleCity.title}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                            <div className="col-md-6">
                              <div className="labelClass">
                                <label for="">Barangay</label>
                              </div>
                              <select
                                name="barangay"
                                id="barangay"
                                value={encashmentRequest.barangay}
                                onChange={encashmentonChange}
                                defaultValue=""
                                disabled={true}
                              >
                                <option value="">Select Barangay</option>
                                {valueForAddress.barangay.map(
                                  (singleBarangay) => {
                                    return (
                                      <option value={singleBarangay.value}>
                                        {singleBarangay.title}
                                      </option>
                                    );
                                  }
                                )}
                              </select>
                            </div>
                            {/* street zip code*/}
                            <div className="col-md-6">
                              <div className="labelClass">
                                <label for="">Street/Building Name*</label>
                              </div>
                              <input
                                placeholder="Street/Building Name"
                                type="text"
                                name="street"
                                value={encashmentRequest.street}
                                disabled={true}
                              />
                            </div>
                            <div className="col-md-6">
                              <div className="labelClass">
                                <label for="">Zip Code:</label>
                              </div>
                              <input
                                placeholder="Zip Code"
                                type="text"
                                name="zipcode"
                                value={encashmentRequest.zipcode}
                                disabled={true}
                              />
                            </div>
                            {/* <div className="col-md-6"></div>
                            <div className="col-md-6">
                              <button
                                type="button"
                                style={{
                                  backgroundColor: "#00AF50",
                                  padding: ".5em",
                                  borderRadius: ".2em",
                                }}
                              >
                                Save
                              </button>
                            </div> */}
                          </>
                        )}
                      </>
                    )}
                    {/* <div className="col-md-6"></div> */}
                    <div className="col-md-6">
                      <div className="labelClass">
                        <label for="">Debit Amount</label>
                      </div>
                      <input
                        placeholder="Debit Amount"
                        type="text"
                        value={encashmentRequest.debitAmount}
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-6">
                      <div className="labelClass">
                        <label for="">Enter Password *</label>
                      </div>
                      <input
                        placeholder="Enter Password"
                        type="password"
                        name="password"
                        value={encashmentRequest.password}
                        onChange={encashmentonChange}
                      />
                    </div>
                    {encashmentRequest.releaseMethod === "pickup-assigned" && (
                      <div>
                        <div className="col-md-6">
                          <div className="labelClass">
                            <label for="">Download PDF</label>
                          </div>
                          <a href={props.pdf} className="filebutton">
                            Download <span className="iconStyle">⬇</span>{" "}
                          </a>
                        </div>
                      </div>
                    )}
                    {encashmentRequest.releaseMethod === "pickup-assigned" && (
                      <div className="col-md-6">
                        <div className="labelClass">
                          <label for="">Upload PDF</label>
                        </div>
                        <input
                          type="file"
                          name="file"
                          className="filebutton"
                          accept=".pdf,application/pdf"
                          onChange={encashmentonChange}
                        />
                      </div>
                    )}
                  </div>

                  <br />
                </div>
                <button
                  type="button"
                  style={{
                    backgroundColor: "#00AF50",
                    padding: "1em",
                    borderRadius: ".2em",
                  }}
                  disabled={encashmentRequest.loading}
                  onClick={encashmentRequestSubmit}
                >
                  {encashmentRequest.loading ? "Loading" : "Process Encashment"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      {notify.show && (
        <div>
          <AlertMessage
            message={notify.message}
            dismiss={notifyDissmissed}
            type={notify.type}
            header={notify.header}
            show={notify.show}
          />
        </div>
      )}
    </div>
  );
}

export default NewModal;
